// @ts-nocheck

import eventBus from "@legacy/modules/event-bus.module.ts";
import { commonState } from "@legacy/modules/common-state.module.ts";
import { showPopup } from "@legacy/modules/popup.module.ts";
import { getQuantityAttributes } from "@legacy/modules/cart.module.ts";

// @ts-ignore
const processedCartItemQuantityControls = new WeakSet();

/**
 * инициализация для элементов которые добавляют продукты в корзину
 */
function initHandleUpdateCart() {
    /**
     * @type {NodeListOf<HTMLElement>}
     */
    const elements = document.querySelectorAll("[data-handle-add-to-cart]");

    for (const elem of elements) {
        // не навешиваем обработчики дважды
        if (processedCartItemQuantityControls.has(elem)) continue;

        if (elem instanceof HTMLInputElement) {
            // события элемнта input
            // При вводе, если введенное значение корректное, изменить количество товара
            elem.addEventListener("input", () => {
                const attr = getQuantityAttributes(elem);
                let newQuantity = parseInt(elem.value);
                if (!Number.isNaN(newQuantity)) {
                    attr.setQuantity(newQuantity, false);
                }
            });
            // При снятии фокуса, восстановить последнее корректное значение количества
            elem.addEventListener("focusout", () => {
                const attr = getQuantityAttributes(elem);
                attr.resetInputValue();
            });
            // При нажатии Enter изменить количество товара
            elem.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    const attr = getQuantityAttributes(elem);
                    let newQuantity = parseInt(elem.value);
                    if (Number.isNaN(newQuantity)) {
                        attr.resetInputValue();
                    } else {
                        attr.setQuantity(newQuantity);
                    }
                }
            });
        }

        const isIncreaseControl = "increase" in elem.dataset;
        const isDecreaseControl = "decrease" in elem.dataset;
        if (
            elem instanceof HTMLButtonElement &&
            (isIncreaseControl || isDecreaseControl)
        ) {
            // события кнопок
            addQuantityButtonClickHandler(elem);

            if (isIncreaseControl === isDecreaseControl) {
                console.error(
                    `Check quantity control button attributes. Forbidden "increase" and "decrease" attributes at once. Element: ${elem}`,
                );
                continue;
            }

            if (isIncreaseControl) {
                const { quantity, quantityMax } = getQuantityAttributes(elem);
                elem.disabled = quantity >= quantityMax;
            }

            if (isDecreaseControl) {
                const { quantity, quantityMin } = getQuantityAttributes(elem);
                elem.disabled = quantity <= quantityMin;
            }
        }

        processedCartItemQuantityControls.add(elem);
    }

    /**
     * Добавить обработчик клика на кнопки изменения количества товара корзине
     * @param {HTMLButtonElement} elem
     */
    function addQuantityButtonClickHandler(elem) {
        elem.addEventListener("click", () => {
            const attr = getQuantityAttributes(elem);
            let newQuantity = attr.quantity + attr.amountChange;
            attr.setQuantity(newQuantity);
        });
    }
}

initHandleUpdateCart();

// вписать новое кол-во во все элементы на странице которые содержат класс .js-cart-counter
eventBus.subscribe("cart-changed", ({ total }) => {
    const elements = document.querySelectorAll(".js-cart-counter");
    for (const element of elements) {
        element.innerHTML = total;
    }
});

const totalElements = document.querySelectorAll(".js-cart-total");
const subtotalElements = document.querySelectorAll(".js-cart-subtotal");
const discountElements = document.querySelectorAll(".js-cart-discount");
// вписать сумму корзины во все элементы на странице которые содержат класс .js-cart-total
eventBus.subscribe("cart-changed", ({ totalPrice, discountedTotal }) => {
    for (const element of totalElements) {
        if (discountedTotal !== null) {
            element.innerHTML = formatMoney(discountedTotal);
        } else {
            element.innerHTML = formatMoney(totalPrice);
        }
    }
    for (const element of subtotalElements) {
        element.innerHTML = formatMoney(totalPrice);
    }
    for (const element of discountElements) {
        if (discountedTotal !== null) {
            const diff = totalPrice.value - discountedTotal.value;
            element.innerHTML = formatMoney({
                value: diff,
                currency: totalPrice.currency,
            });
        }
    }
});

// Показать уведомление при попытке добавить больше товара, чем есть в наличии
eventBus.subscribe("not-enough-products", ({ message }) => {
    showPopup(message, 2000, 10);
});

/**
 * Преобразование денежной суммы в строку
 * @param {Object} param
 * @param {number} param.value сумма
 * @param {string} param.currency валюта
 */
function formatMoney({ value, currency }) {
    /** @type {Intl.NumberFormatOptions} */
    const formatOptions = Number.isInteger(value)
        ? { style: "decimal", maximumFractionDigits: 0 }
        : {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          };
    const numberFormat = new Intl.NumberFormat("ru", formatOptions);
    const formattedValue = numberFormat.format(value);
    let currencySymbol = commonState.localization.currencySymbols[currency];
    if (!currencySymbol) {
        currencySymbol = "";
    }
    if (commonState.localization.currentCulture === "en") {
        return `${currencySymbol} ${formattedValue}`;
    } else {
        return `${formattedValue} ${currencySymbol}`;
    }
}
